import { FormLabel, Stack } from '@chakra-ui/react';
import useAllRolesQuery from 'hooks/useAllRolesQuery';
import { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

interface MultiSelectDropDownProps {
  roles: Array<string>;
  setRoles: Dispatch<any>;
  allRolesSelected?: boolean;
}

export function MultiSelectRolesDropDown({ roles, setRoles, allRolesSelected }: MultiSelectDropDownProps) {
  const { t } = useTranslation();
  const allRolesQuery = useAllRolesQuery();

  const styles = {
    clearIndicator: (styles: any) => ({
      ...styles,
      color: 'red',
    }),
    placeholder: (styles: any) => ({
      ...styles,
      color: 'black',
    }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      color: 'black',
    }),
    menuList: (styles: any) => ({
      ...styles,
      paddingLeft: '10px',
      paddingRight: '10px',
      backgroundColor: 'gray',
      borderRadius: '4px',
      borderColor: 'black',
      border: '2px',
    }),
    control: (styles: any) => ({
      ...styles,
      backgroundColor: 'white',
      borderColor: 'gray.200',
      borderRadius: '6px',
      minHeight: '40px',
    }),
    option: (styles: any, { isFocused }: any) => {
      return {
        backgroundColor: isFocused ? '#6094ec' : 'gray',
        color: 'white',
        borderRadius: '4px',
      };
    },
  };

  const selectedStatus = roles.map((name) => {
    const label = allRolesQuery.data?.find((role: { name: string; label: string }) => role.name === name)?.label;

    return {
      value: name,
      label: label,
    };
  });

  const dropdownOptions = allRolesQuery.data?.map(({ name, label }: { name: string; label: string }) => ({
    value: name,
    label,
  }));

  return (
    <Stack direction={'column'} width={'300px'} mt={5}>
      <FormLabel size="lg" pl="1" mb={0}>
        {t('user:roles')}
      </FormLabel>
      <Select
        isMulti
        placeholder={t('components:table.filters.select')}
        styles={styles}
        isClearable={true}
        aria-label={'multiselect-filter'}
        value={selectedStatus}
        options={dropdownOptions}
        // Fixes the overlapping problem of the dropdown
        menuPosition={'fixed'}
        onChange={(selectedOptions) => {
          // Extract an array of values from the selected options
          const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value.toString()) : [];

          setRoles(selectedValues);

          // Clear the status if allStatusSelected is true
          if (allRolesSelected) {
            setRoles([]);
          }
        }}
      />
    </Stack>
  );
}
